<template>
  <div id="idc-header" class="w-100 d-flex align-items-center">
    <div class="collcapse-menu">
      <i class="ml-3 mr-2 el-icon-s-fold hover" @click="switchCollapse">
      </i>
    </div>
    <div class="breadcrumb">
      {{filterCurrentPage(currentPage)}}
    </div>
    <el-menu class="ml-auto menu border-0" mode="horizontal">
      <el-menu-item>
        <el-dropdown trigger="click">
          <el-button type="success" >
            <i class="el-icon-plus text-white"></i>
            <span class="text-white">{{$t('create')}}</span>
            <i class="el-icon-arrow-down el-icon--right mx-0 text-white"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <router-link :to="{name: 'cloud-server.create'}">Server</router-link>
            </el-dropdown-item>
            <el-dropdown-item>
              <router-link :to="{name: 'volume.create'}">Volume</router-link>
            </el-dropdown-item>
            <el-dropdown-item>
              <router-link :to="{name: 'snapshot.create'}">Snapshot</router-link>
            </el-dropdown-item>
            <el-dropdown-item>
              <router-link :to="{name: 'ssh-keys.create'}">SSH Key</router-link>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-menu-item>
      <el-dropdown trigger="click" class="menubar-xs">
        <div class="el-dropdown-link hover p-1">
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <el-tooltip class="item" effect="dark" :content="$t('header.unpaidAmount')" placement="bottom">
              <span>
                <i class="el-icon-money"></i> {{userInfo.unpaid_amount | currency}} đ
              </span>
            </el-tooltip>
          </el-dropdown-item>
          <el-dropdown-item>
            <span class="el-dropdown language">
              <i class="idc-icons mr-0-8" :class="locale === 'vi' ? 'icon-flag-en' : 'icon-flag-vi'"></i>
              {{locale === 'vi' ? $t('languageEn') : $t('languageVi')}}
              <i class="el-icon-arrow-down el-icon--right ml-0-8"></i>
            </span>
            <div class="ml-1">
              <span class="d-flex align-items-center" @click="setLocale('en')">
                <i class="idc-icons icon-flag-en"></i>
                {{$t('languageEn')}}
              </span>
              <span class="d-flex align-items-center" @click="setLocale('vi')">
                <i class="idc-icons icon-flag-vi"></i>
                {{$t('languageVi')}}
              </span>
            </div>
          </el-dropdown-item>
          <el-dropdown-item>
            <span class="el-dropdown">
              <i class="el-icon-user el-icon--right mx-0"></i>
              <span class="text-limited user p-0">{{userInfo ? (userInfo.fullname ? userInfo.fullname : userInfo.email) : null}}</span>
              <i class="el-icon-arrow-down el-icon--right mx-0"></i>
            </span>
            <div class="ml-1">
              <router-link :to="{name: 'account.index'}"><i class="el-icon-user el-icon--right mx-0"></i> {{$t('header.account')}}</router-link>
              <router-link :to="{name: 'billing.index'}"><i class="el-icon-money el-icon--right mx-0"></i> {{$t('header.billing')}}</router-link>
              <a href="#" @click="handleLogout()">
                <i class="el-icon-lock el-icon--right mx-0"></i>
                {{$t('signOutMenuTxt')}}
              </a>
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="menubar-lg">
        <el-menu-item v-if="userInfo && userInfo.unpaid_amount > 0"
                      @click="gotoPage('billing.index')">
          <el-tooltip class="item" effect="dark" :content="$t('header.unpaidAmount')" placement="bottom">
          <span>
            <i class="el-icon-money"></i> {{userInfo.unpaid_amount | currency}} đ
          </span>
          </el-tooltip>
        </el-menu-item>
        <el-menu-item>
          <el-dropdown trigger="click">
          <span class="el-dropdown">
            <i class="idc-icons" :class="locale === 'en' ? 'icon-flag-en' : 'icon-flag-vi'"></i>
            {{locale === 'en' ? $t('languageEn') : $t('languageVi')}}

            <i class="el-icon-arrow-down el-icon--right mx-0"></i>
          </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
              <span class="d-flex align-items-center" @click="setLocale('en')">
                <i class="idc-icons icon-flag-en"></i>
                {{$t('languageEn')}}
              </span>
              </el-dropdown-item>
              <el-dropdown-item @click="setLocale('vi')">
              <span class="d-flex align-items-center" @click="setLocale('vi')">
                <i class="idc-icons icon-flag-vi"></i>
                {{$t('languageVi')}}
              </span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-menu-item>
        <el-menu-item>
          <el-dropdown trigger="click">
            <div class="el-dropdown">
              <i class="el-icon-user el-icon--right mx-0"></i>
              <span class="text-limited user">{{userInfo ? (userInfo.fullname ? userInfo.fullname : userInfo.email) : null}}</span>
              <i class="el-icon-arrow-down el-icon--right mx-0"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <router-link :to="{name: 'account.index'}"><i class="el-icon-user el-icon--right mx-0"></i> {{$t('header.account')}}</router-link>
              </el-dropdown-item>
              <el-dropdown-item>
                <router-link :to="{name: 'billing.index'}"><i class="el-icon-money el-icon--right mx-0"></i> {{$t('header.billing')}}</router-link>
              </el-dropdown-item>
              <el-dropdown-item>
                <a href="#" @click="handleLogout()">
                  <i class="el-icon-lock el-icon--right mx-0"></i>
                  {{$t('signOutMenuTxt')}}
                </a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-menu-item>
      </div>
    </el-menu>
  </div>
</template>
<script>
  import authService from '@/services/auth'
  export default {
    name: 'header-menu',
    props: ['userInfo', 'currentPage', 'isHasNotify', 'isCollapse'],
    data () {
      return {
        locale: localStorage.locale
      }
    },
    watch: {
      'isHasNotify' (value) {
        this.checkIsHasNotify()
      }
    },
    methods: {
      filterCurrentPage (value) {
        switch (value) {
          case 'dashboard':
            return 'Dashboard'
          case 'cloud-server':
            return 'Cloud Server'
          case 'plan':
            return this.$t('sidebarMenu.plan')
          case 'volume':
            return 'Volume'
          case 'snapshot':
            return 'Snapshot'
          case 'ssh-keys':
            return 'SSH Key'
          case 'account':
            return this.$t('header.account')
          case 'billing':
            return this.$t('header.billing')
          case 'ticket':
            return this.$t('header.ticket')
          case 'agency':
            return this.$t('agency.title')
        }
      },
      checkIsHasNotify () {
        if (this.isHasNotify) {
          document.getElementById('idc-header').style.paddingTop = '50px'
        } else {
          document.getElementById('idc-header').style.paddingTop = '0'
        }
      },
      getUserInfo () {
        // authService.check()
      },
      setLocale (locale) {
        this.locale = locale
        this.$emit('setLocale', locale)
        localStorage.locale = locale
      },
      gotoPage (name) {
        if (this.$router.history.current.name === name) return
        this.$router.push({name: name})
      },
      switchCollapse () {
        document.getElementById('idc-sidebar').classList.add('show')
        this.$emit('switchCollapse', false)
      },
      handleLogout () {
        authService.logout()
      }
    },
    filters: {
    },
    mounted () {
      this.checkIsHasNotify()
      this.getUserInfo()
      if (localStorage.locale) {
        this.locale = localStorage.locale
      } else {
        this.locale = 'vi'
      }
      this.setLocale(this.locale)
    }
  }
</script>
<style scoped>
  .el-icon-s-fold {
    font-size: 20px;
  }
  .breadcrumb, .language {
    color: #909399;
  }
  .user {
    display: inline-block;
    max-width: 125px;
  }
</style>



// WEBPACK FOOTER //
// src/views/idc/components/header.vue